import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKlachtOverlastMelden = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M31 8v24h-8l-3 4-3-4H9V8z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="m22.01 36-4.24-5H10v-5.25h1V30h7.23l4.55 5.35z"
    />
    <path
      fill="#fff"
      d="M20 28c-.53 0-.98-.18-1.34-.54s-.54-.8-.54-1.31.19-.98.56-1.35.81-.56 1.33-.56.96.19 1.33.56.56.82.56 1.35-.18.95-.54 1.31-.81.54-1.34.54zm-1.86-16h3.72l-.64 10.38h-2.45L18.13 12z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKlachtOverlastMelden);

export default ForwardRef;
